<template>
  <page-template>
    <board :is-fold="isFold"
           :http-options="httpOptions"
           :config="config"
           :insert-row-function="() => insertRow('createEmptyCuration')"
           :delete-row-function="(rows) => deleteRow('deleteCurations', rows)"
           :disabled-play-button="true"/>
  </page-template>
</template>

<script>
import Vue from 'vue';

import CurationAction from './detail-row/CurationAction';
import config from './Config';
import CommonBoardItems from '../CommonBoardItems';

import Editor from './detail-row/CurationEditor';

Vue.component(config.detailRowComponentName, Editor);
Vue.component(config.customActionComponentName, CurationAction);

export default {
  name: 'BoardCuration',
  mixins: [CommonBoardItems],
  data() {
    return {
      config,
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/spa/components/board/curation/BoardCuration.vue